/* @flow */

import React from 'react'
import ApiStatus from '../../../components/ApiStatus'
export default () => <ApiStatus />
